var render = function render(){var _vm=this,_c=_vm._self._c;return _c('n-button-icon',{staticStyle:{"width":"35px"},attrs:{"custom-icon":"far fa-clone","ghost":"","disabled":_vm.disabled},on:{"on-click":function($event){return _vm.$emit('on-click')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }